<a class="db-btn-solid db-btn-solid--full" [routerLink]="['/d', league.hash]">Enter draft room →</a>
<button class="db-btn-ghost db-btn-ghost--full" (click)="edit.emit(league)">League settings</button>
<button class="db-btn-ghost db-btn-ghost--full" (click)="exportCSV()" [disabled]="exporting()">{{ exporting() ? 'Exporting…' : 'Export rosters CSV' }}</button>
@if (league.is_commissioner) {
  <button class="db-btn-ghost db-btn-ghost--full db-btn-danger" (click)="delete.emit(league)">Delete league</button>
}
